import { register, getPrefix } from '../../../Utils'

const OffcanvasMenu = el => {
  const prefix = getPrefix(el)

  const linkItems = el.querySelectorAll(`.${prefix}link-item`)
  const targetItems = el.querySelectorAll(`.${prefix}target-item`)
  const level2Layer = el.querySelector(`.${prefix}level-2`)
  const backLink = el.querySelector(`.${prefix}back-link`)

  const clickLinkItem = (e) => {
    e.preventDefault()

    const item = e.currentTarget
    const targetId = item.dataset.linkId ? item.dataset.linkId : 0
    const linkLevel = item.dataset.linkLevel ? item.dataset.linkLevel : 0

    linkItems.forEach(linkItem => {
      if (linkLevel === linkItem.dataset.linkLevel) {
        linkItem.classList.toggle(`${prefix}is--active`, targetId === linkItem.dataset.linkId)
      }
    })

    targetItems.forEach(targetItem => {
      if (linkLevel === targetItem.dataset.targetLevel) {
        targetItem.classList.toggle(`${prefix}is--active`, targetId === targetItem.dataset.targetId)
      }
    })

    // add active to linkItem with id
    // add active to linkTagret with id

    if (item.classList.contains(`${prefix}level-1-link`)) {
      level2Layer.classList.add(`${prefix}is--active`)
    }
  }

  const clickBackLink = (e) => {
    e.preventDefault()

    level2Layer.classList.remove(`${prefix}is--active`)

    linkItems.forEach(linkItem => {
      linkItem.classList.remove(`${prefix}is--active`)
    })

    targetItems.forEach(targetItem => {
      targetItem.classList.remove(`${prefix}is--active`)
    })
  }

  linkItems.forEach(item => {
    item.addEventListener('click', clickLinkItem)
  })

  backLink.addEventListener('click', clickBackLink)
}

register('OffcanvasMenu', OffcanvasMenu)
